export function filterElementsRowsForLinkModal<T extends { object_list_id?: number }>(
  rows: T[],
  boundIds: Set<number>,
): T[] {
  return rows.filter((r) => {
    const id = Number(r.object_list_id)
    return !Number.isFinite(id) || id <= 0 || !boundIds.has(id)
  })
}
